import React from 'react';
import DataTable from 'components/data-table';
import {RowItemAddReceptionPeriodical, RowItemListBriefJob} from 'modules/reception-periodical/datatable/add';
import {header} from "constants/table";
import { Button } from '@blueprintjs/core';
import { Reception } from 'api';
import { Link, browserHistory } from 'react-router';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import moment from 'moment';
import axios from 'axios';
import { API_URL } from 'constants/config';
import {DropDown, DatePicker, Input} from 'components/tt-forms/common';
import {
  DropDownChonLoaiDonThu,
  DropDownChonLinhVucDonThu,
  DropDownChonLinhVucDonThuChiTiet
} from 'components/tt-forms';
import {ConfirmDialog} from 'modules/dialog';
import {MasterLayout} from 'layout';
import { DetailReception } from 'modules/reception-periodical/popup-detail';

class AddReceptionPeriodical extends React.Component {
  constructor(props, context) {
    super(props, context);
     this.state = {
      isSubmit: false,
      selectedDate: Date,
      closeOnSelection: true,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tableLoading: false,
      isEnabled: false,
      DataLanhDao: [],
      DataDon: [],
      DataLoaiDonThu: [],
      dsCoQuanToChucTiepDan: [],
      hoSoTuNgay: moment().startOf('month'),
      hoSoDenNgay: moment().endOf('month'),
      diaDiemTiep: '',
      donViTiepDan: '',
      saveLoading: false,
      selectAll: false,
      loadData: false,
      ngayTiepNhan: moment(),
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,
      ngayTiepValid: true,
      loaiDonId: '',
      linhVucCap1Id: '',
      linhVucCap2Id: '',
      linhVucCap3Id: '',
      donDaChon: [],
      backConfirm: false,
      hasChange: false,
      detailPopupStatus: false,
      detailPopupInfo: {noiDung: ''}
    }
  }

  componentDidMount() {
    this.getSelectLanhDaoTiep();
    this.getListHoSo();
    this.getListLoaiDonThu();
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    if (name == 'loaiDonId') {
      this.state.linhVucCap1Id = '';
      this.state.linhVucCap2Id = '';
      this.state.linhVucCap3Id = '';
    }
    if (name == 'linhVucCap1Id') {
      this.state.linhVucCap2Id = '';
      this.state.linhVucCap3Id = '';
    }
    if (name == 'linhVucCap2Id') {
      this.state.linhVucCap3Id = '';
    }

    this.state[name] = e.target.value;
    this.state.hasChange = true;
    this.setState({...this.state})
  }

  getSelectLanhDaoTiep() {
    Reception.actions.getListLanhDao.request().then(res => {
      if (res.data) {
        this.setState({
          DataLanhDao: res.data._embedded.congChucs
        });
      }
    });
  }

  getListHoSo(type) {
    if (this.validateForm()) {
      let params = {
        tuNgay: moment().startOf('month').format(),
        denNgay: moment().endOf('month').format(),
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (type == "search") {
        this.setState({
          search: true
        });
        if (this.state.hoSoTuNgay){
          params.tuNgay = moment(this.state.hoSoTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
        if (this.state.hoSoDenNgay){
          params.denNgay = moment(this.state.hoSoDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
        if (this.state.linhVucCap1Id) {
          params.linhVucId = this.state.linhVucCap1Id;
        }
        if (this.state.linhVucCap2Id) {
          params.linhVucChiTietChaId = this.state.linhVucCap2Id;
        }
        if (this.state.linhVucCap3Id) {
          params.linhVucChiTietConId = this.state.linhVucCap3Id;
        }
        if (this.state.loaiDonId) {
          params.loaiDon = this.state.loaiDonId;
        }
      }

      this.setState({
        loadData: true
      });
      Reception.actions.gethoSoVuViec.request(params).then(res => {
        if (res.data._embedded) {
          res.data._embedded.dons.map((item, i) => {
            if (this.state.donDaChon.indexOf(item.donId) != -1) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          this.setState({
            DataDon: res.data._embedded.dons,
            pageData: res.data.page
          });
        } else {
          this.setState({
            DataDon: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
        this.setState({
          search: false,
          selectAll: false,
          loadData: false,
          searchSubmit: false
        });
      });
    }
  }

  validateForm(){
    this.setState({searchSubmit: true});
    let pass = true;
    if (this.state.hoSoTuNgay) {
      this.state.startDateValid = moment(this.state.hoSoTuNgay, 'DD/MM/YYYY').isValid();
      if (pass)
        pass = this.state.startDateValid;
      this.setState({startDateValid: this.state.startDateValid});
    }
    if (this.state.hoSoDenNgay) {
      this.state.endDateValid = moment(this.state.hoSoDenNgay, 'DD/MM/YYYY').isValid();
      if (pass)
        pass = this.state.endDateValid;
      this.setState({endDateValid: this.state.endDateValid});
    }
    return pass;
  }

  createData(){
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (this.checkValidate()) {
      this.setState({saveLoading: true});
      let params = {
        canBoTiepDan: {id: this.state.congChucId},
        loaiTiepDan: 'DINH_KY'
      };

      if (userInfo) {
        params.donViId = userInfo.donViId;
        params.congChucId = userInfo.id;
      }

      if (this.state.diaDiemTiep) {
        params.diaDiemGapLanhDao = this.state.diaDiemTiep;
      }

      if (this.state.ngayTiepNhan) {
        params.ngayTiepDan = moment(this.state.ngayTiepNhan).add(7, 'hours').toISOString();
      }

      if(this.state.dsCoQuanToChucTiepDan.length > 0){
        params.coQuanToChucTiepDans=[];
        this.state.dsCoQuanToChucTiepDan.map((item, i)=>{
          let cqData = {
            chucVu: item.chucVu,
            nguoiDaiDien: item.nguoiDaiDien,
            coQuanDonVi: {id: item.tencoquan}
          };
          params.coQuanToChucTiepDans.push(cqData);
        });
      }

      this.state.DataLanhDao.map((item, i)=>{
        if(item.congChucId == this.state.congChucId){
          params.donViTiepDan = {id: item.donViCongChuc.coQuanQuanLyId}
        }
      });
      this.processCreateTCD(this.state.donDaChon, 0, params);
    }
  }

  processCreateTCD (list, index, params) {
    params.don = {id: list[index]};
    axios.post(`${API_URL}/soTiepCongDans`, params).then(res => {
      if (index < list.length -1) {
        this.processCreateTCD(list, index+1, params);
      } else {
        Toastr(msg.createSuccess, 'success');
        setTimeout(() => {
          browserHistory.goBack();
        }, 1000);
      }
    }).catch((error) => {
      if (index < list.length -1) {
        this.processCreateTCD(list, index+1, params);
      } else {
        this.setState({saveLoading: false});
        Toastr('Đã có lỗi xảy ra, vui lòng thử lại!', 'error');
      }
    });
  }

  checkValidate() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    if (pass) {
      pass = moment(this.state.ngayTiepNhan, 'DD/MM/YYYY').isValid();
    }

    let isCheck = this.state.donDaChon.length > 0;

    if (!isCheck) {
      Toastr(msg.datDonPeriodical, 'warning');
      pass = false;
    }
    return pass;
  }

  getListLoaiDonThu(){
    Reception.actions.getLoaiDonThu.request().then(res => {
      if (res.data) {
        this.setState({DataLoaiDonThu: res.data});
      }
    });
  }

  handleRemove(index, name) {

    this.state[name].splice(index, 1);
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  handleChangeEditableTLBS (index, name, value) {
    this.state.dsCoQuanToChucTiepDan[index][name] = value;
    this.setState({dsCoQuanToChucTiepDan: this.state.dsCoQuanToChucTiepDan, hasChange: true});
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListHoSo();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListHoSo();
  }

  handleChangeCheckbox(item, e){
    item.checked = !item.checked;
    if (item.checked) {
      this.state.donDaChon.push(item.donId);
    } else {
      this.state.donDaChon.splice(this.state.donDaChon.indexOf(item.donId), 1);
    }
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  handleChangeCheckboxAll(index, e){
    this.state.isEnabled = !this.state.isEnabled;
    this.setState({...this.state});
    this.state.DataDon.map((item, i) => {
      item.checked = this.state.isEnabled
      this.setState({...this.state});
    });
  }

  addCoQuan() {
    let arrLength = this.state.dsCoQuanToChucTiepDan.length;
    if (arrLength == 0 || (arrLength > 0 && this.state.dsCoQuanToChucTiepDan[arrLength - 1].tencoquan != '')) {
      this.state.dsCoQuanToChucTiepDan[this.state.dsCoQuanToChucTiepDan.length] = {
        tencoquan: null,
        nguoiDaiDien: '',
        chucVu: ''
      };
      this.setState({
        dsCoQuanToChucTiepDan: this.state.dsCoQuanToChucTiepDan,
        hasChange: true
      });
    }
  }
  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.state.hasChange = true;
    this.setState({...newData});
  }

  handleChange(e){

    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        browserHistory.goBack();
      }
    }
  }
  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  handleClickDetail(item, status) {
    this.setState({
      detailPopupStatus: status,
      detailPopupInfo: item
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div className="panel-page add-reception-periodical">
        <DetailReception
          noiDung = {this.state.detailPopupInfo.noiDung}
          item={this.state.detailPopupInfo}
          isOpen={this.state.detailPopupStatus}
          onClose={this.handleClickDetail.bind(this, {}, false)}
        />
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="center">
          <div className="back-foward">
            <Link onClick={this.handleBack.bind(this, false)} title="" >Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">Thêm mới cuộc tiếp định kỳ của lãnh đạo</h2>
          </div>
          <div className="main_page">
            <form className="form">
              <div className="wrapper_box">
                <div className="box-items mb0">
                  <div className="box-forward">
                    <div className="container-box">
                      <div className="group-box">
                        <div className="items-form inline-bottom">
                          <div className="rows">
                            <DropDown className="col-input" label="Lãnh đạo tiếp" selectedValue={this.state.congChucId} require={true} options={this.state.DataLanhDao} keyName="congChucId" valueName="hoVaTen" placeholder
                              onChange={this.onChange.bind(this, 'congChucId')} bindValidator={this} channel="formTaoDon" name="dropdownChonLanhDaoTiep"/>
                            <DatePicker className="col-input" label='Ngày tiếp' bindValidator={this} channel="formTaoDon" timeFormat="HH:mm" onChange={ this.handleChangeDate.bind(this, 'ngayTiepNhan') } value={this.state.ngayTiepNhan} maxLength={18} dateFormat="DD/MM/YYYY -"/>
                            <Input className="col-w60" label="Địa điểm" value={this.state.diaDiemTiep} onChange={this.onChange.bind(this, 'diaDiemTiep')} name="inputDiaDiem"/>
                          </div>
                        </div>
                      </div>
                      <div className="group-box">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Danh sách cơ quan, các đơn vị cùng tham gia tiếp công dân</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form pb15">
                          <div className="rows">
                            <div className="col-12 white-table row-center">
                              <DataTable
                                header = {header.receptionPeriodical.add}
                                dataList = {this.state.dsCoQuanToChucTiepDan}
                                hidePagination={true}
                                hideExport={true}
                                showAddMore={true}
                                addMore={this.addCoQuan.bind(this)}
                                parent={this}>
                                <RowItemAddReceptionPeriodical bindValidator={this} />
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="box-items">
                  <div className="box-forward">
                    <div className="container-box">
                      <div className="group-box">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Chọn đơn/vụ việc được lãnh đạo tiếp</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form wrap-block">
                          <div className="row pl15 pr15">
                            <DatePicker className="col-16 input-inside" label='Tiếp nhận từ ngày' bindValidator={this} channel="formTaoDon" endDate={ this.state.hoSoDenNgay }
                              onChange={ this.handleChangeDate.bind(this, 'hoSoTuNgay') } value={this.state.hoSoTuNgay} name="dinhKyTuNgay"/>
                            <DatePicker className="col-16 input-inside" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={ this.state.hoSoTuNgay }
                              onChange={ this.handleChangeDate.bind(this, 'hoSoDenNgay') } value={this.state.hoSoDenNgay} name="dinhKyDenNgay"/>
                            <DropDownChonLoaiDonThu className="col-16 input-inside" name="loaiDonThu" selectedValue={this.state.loaiDonId} label="Loại đơn" onChange={this.onChange.bind(this, 'loaiDonId')}/>
                            <DropDownChonLinhVucDonThu className="col-16 input-inside" name="linhVucDonThu" selectedValue={this.state.linhVucCap1Id} loaiDonThuID={this.state.loaiDonId} onChange={this.onChange.bind(this, 'linhVucCap1Id')}/>
                            <DropDownChonLinhVucDonThuChiTiet className="col-16 input-inside" loaiDonThuID={this.state.loaiDonId} selectedValue={this.state.linhVucCap2Id} linhVucDonThuID={this.state.linhVucCap1Id} onChange={this.onChange.bind(this, 'linhVucCap2Id')} name="linhVucDonThuChiTiet"/>
                            <DropDownChonLinhVucDonThuChiTiet className="col-16 input-inside" loaiDonThuID={this.state.loaiDonId} selectedValue={this.state.linhVucCap3Id} label="&nbsp;" linhVucDonThuID={this.state.linhVucCap2Id} onChange={this.onChange.bind(this, 'linhVucCap3Id')} name="linhVucDonThuChiTietCon"/>
                            <div className="col-100 mb18 txt-center">
                              <Button
                                className={`btn-green tt-search ${this.state.search ? 'btn-loading-inline' : (this.state.loadData ? 'btn-disable' : '')}`}
                                text="Lấy danh sách"
                                onClick={this.getListHoSo.bind(this, 'search')}
                              />
                            </div>
                            <div className="col-100 pb20">
                              <span className="line-border"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="group-box">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Danh sách đơn/vụ việc</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form add-periodical-custom-table">
                          <div className="rows">
                            <div className="col-12">
                              <DataTable
                                header = {header.receptionPeriodical.listBriefJob}
                                dataList = {this.state.DataDon}
                                pageData={this.state.pageData}
                                parent={this}
                                tableLoading={this.state.loadData}
                                search = {this.state.search}
                                hideExport ={true}>
                                <RowItemListBriefJob onClickDetail={this.handleClickDetail.bind(this)}/>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.handleBack.bind(this, false)}>
                  <span>Đóng</span>
                </Link>
                <Link className={`btn-action btn-save ${this.state.loadData ? 'btn-disable' : (this.state.saveLoading ? 'btn-loading-inline' : '')}`} onClick={this.createData.bind(this)}>
                  <span>Lưu</span>
                </Link>
              </div>
            </form>
          </div>
          {/*main_page*/}
        </div>
      </div>
      </MasterLayout>
    );
  }
}

AddReceptionPeriodical.defaultProps = {
  validators: []
}

export default AddReceptionPeriodical;



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/add-reception-periodical/AddReceptionPeriodical.jsx